import { $ } from '@/libs/jquery/index'

$.validator.addMethod('citizenship', function(value: string, element: HTMLElement): boolean {
  // если данные не из дадаты, то ошибка
  let correct = ($(element).data('getdadata') === 1) && (value !== '')
  correct = correct && (value.length === 3) && (/^.[a-zA-Z]+$/i).test(value)

  return this.optional(element) || correct
}, 'Поле заполнено некорректно.')
